export enum NotificationTopic {
    BladeRefill = 'BladeRefill',
    ConsumableKit = 'ConsumableKit',
    LocationAdded = 'LocationAdded',
    StationMoved = 'StationMoved',
    DesignCreated = 'DesignCreated',
}

export enum SubscriptionScopeType {
    Company = 'Company',
    Reseller = 'Reseller',
    Location = 'Location',
    /** Non-organizational topics (catalog events); rows use ScopeID 0 and any user may subscribe. */
    Global = 'Global',
}

export type TopicGatingFlag = 'BladeTrackingEnabled' | 'KitTrackingEnabled';

/** One entry of the backend topic registry, served by /notifications/topics. Ungated topics have no gatingFlag. */
export type TopicDefinition = {
    topic: NotificationTopic;
    label: string;
    description: string;
    gatingFlag?: TopicGatingFlag;
    scopeTypes: SubscriptionScopeType[];
};

/**
 * An org row (top-level company or reseller) in the caller's scope with each
 * tracking flag resolved direct row -> parent company. Hierarchy is
 * Company > Reseller > Location; reseller rows carry their ParentCompanyID.
 */
export type TopicOrg = {
    CompanyID: number;
    CompanyName: string;
    IsReseller: boolean;
    ParentCompanyID: number | null;
    BladeTrackingEnabled: boolean;
    KitTrackingEnabled: boolean;
};

export type NotificationTopicsResponse = {
    topics: TopicDefinition[];
    orgs: TopicOrg[];
};

/** One subscription row; CognitoSub is null for admin-added external contacts. */
export type NotificationSubscription = {
    Id: number;
    Email: string;
    CognitoSub: string | null;
    Topic: NotificationTopic;
    ScopeType: SubscriptionScopeType;
    ScopeID: number;
    CreatedBy: string | null;
    CreatedAt: string;
};

export type SubscriptionScopeInput = {
    ScopeType: SubscriptionScopeType;
    ScopeID: number;
};

/** "Get Notifications" batch: every (email x topic x scope) combination is subscribed. */
export type PostContactInput = {
    Emails: string[];
    Topics: NotificationTopic[];
    Scopes: SubscriptionScopeInput[];
};

export type DeleteContactInput = {
    Email: string;
    ScopeType: SubscriptionScopeType;
    ScopeID: number;
    Topic?: NotificationTopic;
};
